import React from 'react';
import { useOnboarding } from './OnboardingProvider';
import OnboardingWizard from './OnboardingWizard';
import TheSessionImportModal from './TheSessionImportModal';

// Renders fullscreen overlays: the onboarding wizard and TheSession import prompt.
// Placed in App.js outside AppLayoutWrapper so it sits on top of everything.
// To disable all onboarding: comment out <OnboardingGate /> in App.js (AuthGate).
export default function OnboardingGate() {
  const { showWizard, showTheSessionPrompt } = useOnboarding();

  if (showWizard) return <OnboardingWizard />;
  if (showTheSessionPrompt) return <TheSessionImportModal />;
  return null;
}
